
















































import { Component, Vue } from 'vue-property-decorator'
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import LocationContactCreate from '@/components/Locations/LocationContactCreate.vue'
import { VuetifyConfirmObject } from 'vuetify-confirm';
import DeleteContactLocationRequest from '@/models/ContactLocations/DeleteContactLocationRequest';

@Component({
    name: 'LocationContactsList',
    components: { LocationContactCreate
    }
})
export default class extends GiganautVue {

    async navigateToContact(item: ContactLocationDto) {
        this.$router.push({ name: PageNames.AgencyContactDetails, params: { contactid: item.contactId } });
    }

    get contactLocations(): ContactLocationDto[] {
        return LocationDetailsModule.contactLocations;
    }

    get loading() {
        return LocationDetailsModule.loadingContactLocations;
    }

    created() {
        this.getLocations();
    }

    private getLocations() {
        LocationDetailsModule.getContactLocations();
    }

    async deleteContactLocation(contactLocation: ContactLocationDto) {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this association?', options);
        if (result) {
            const request = new DeleteContactLocationRequest();
            request.contactId = contactLocation.contactId;
            request.contactLocationId = contactLocation.id;
            await LocationDetailsModule.deleteContactLocation(request);
        }
    }

    private search = '';
    
    private headers = [
        { text: 'First Name', value: 'contact.person.firstName' },
        { text: 'Last Name', value: 'contact.person.lastName' },
        { text: 'Job Title', value: 'contact.person.jobTitle' },
        { text: 'Email Address', value: 'contact.person.emailAddress' },
        { text: 'Phone Number', value: 'contact.person.mobilePhoneNumber' },   
        { text: 'Actions' },
    ]
}
